import { AxiosError } from 'axios';
import http from '../shared/HttpCommon';

export interface IngestionAlertRecipient {
  id: string;
  email: string;
  active: boolean;
}

interface DataResponse<T> {
  data: T;
}

const unwrap = <T>(data: T | DataResponse<T>): T =>
  data && typeof data === 'object' && 'data' in data ? (data as DataResponse<T>).data : (data as T);

const list = async (): Promise<IngestionAlertRecipient[]> => {
  const { data } = await http.get('/ingestion-health/recipients');
  return unwrap(data);
};

const create = async (email: string): Promise<IngestionAlertRecipient> => {
  const { data } = await http.post('/ingestion-health/recipients', { email });
  return unwrap(data);
};

const setActive = async (id: string, active: boolean): Promise<IngestionAlertRecipient> => {
  const { data } = await http.patch(`/ingestion-health/recipients/${id}`, { active });
  return unwrap(data);
};

const remove = async (id: string): Promise<void> => {
  await http.delete(`/ingestion-health/recipients/${id}`);
};

export const isIngestionAlertRequestError = (error: unknown, status: number): boolean =>
  (error as AxiosError)?.response?.status === status;

const IngestionAlertService = { list, create, setActive, remove };

export default IngestionAlertService;
